<div [ngClass]="type" class="subscription-banner" layout-space-between>
  <div layout layout-align-items-center>
    <rt-icon [name]="iconName" size="small" margin-right-small-x></rt-icon>
    <span margin-right-small-xx [innerHTML]="bannerMessage"> </span>
    @if (!!linkText) {
      <a class="link" [routerLink]="linkUrl" (click)="linkClick.emit()">
        {{ linkText }}
      </a>
    }
    @if (isDismissible) {
      <rt-icon-button
        (click)="onCloseClick($event)"
        margin-left-auto
        class="close-btn"
        size="small"
        variant="plain"
        iconName="close"
        shape="square"
      >
      </rt-icon-button>
    }
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
